const a = {
  small: "small",
  standard: "medium"
};
export {
  a as sizeToTypographyBodySizeMap
};
